<template>
    <div class="yx-div">
        <div class="yx-div-center">
            <el-table :data="arch_userBaseProductRateInfo" v-loading="loading" size="mini" border
                      :header-cell-style="{background:'#fafafa'}"
                      ref="prodTable"
                      height="100%"
                      style="width: 100%">
                <el-table-column label="产品名称" width="150" align="center">
                    <template slot-scope="scope">
                        <el-tag type="warning" effect="dark" style="height: 25px">
                            <span style="font-size: 15px">{{scope.row.payProduct.productName}}</span>
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="结算价" prop="payProductChannelList" align="center">
                    <template slot="header">
                        <div class="yx-flex-h-between" style="align-items: center">
                            <div style="width: 1px;" />
                            <span>结算价</span>
                            <el-button size="mini" icon="el-icon-refresh-right" type="success" @click="loadData"></el-button>
                        </div>
                    </template>

                    <template slot-scope="scope">
                        <el-table :data="scope.row.payProductChannelList" type="expand" :show-header="false"
                        >
                            <el-table-column width="150" align="center"
                                             label="交易方式">
                                <template slot-scope="scope">
                                    {{scope.row.payName}}
                                </template>
                            </el-table-column>

                            <el-table-column label="费率" prop="userRateList" align="center">
                                <template slot-scope="scope">
                                    <el-table :data="scope.row.userRateList" type="expand" :header-cell-style="{background:'#fafafa'}">
                                        <el-table-column label="费率类型" prop="rateTypeDesc" />
                                        <el-table-column label="费率（%）">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.rate===null">--</span>
                                                <span v-else>{{scope.row.rate}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="单笔固定（元）" >
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.fixRate===null">--</span>
                                                <span v-else>{{scope.row.fixRate}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="单笔最低（元）">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.feeLowest===null">--</span>
                                                <span v-else>{{scope.row.feeLowest}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="单笔封顶（元）">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.feeHighest===null">--</span>
                                                <span v-else>{{scope.row.feeHighest}}</span>
                                            </template>
                                        </el-table-column>

                                    </el-table>
                                </template>
                            </el-table-column>
                        </el-table>

                        <div class="tipTitle" style="display: flex; justify-content: left;">
                            <!--
                            <span style="font-weight:bold;font-size: 12px; color: red;">到账周期：{{scope.row.payProduct.settleCycle===1?'D0':'D1'}}</span>
                            -->
                            <span style="font-weight:normal;font-size: 12px; color: gray;">&nbsp;&nbsp;{{_enums.ProductChannelEnum.getDescById(scope.row.payProduct.productCode)}}</span>
                        </div>

                    </template>
                </el-table-column>
            </el-table>

        </div>
    </div>

</template>

<script>
    import {URL_DATA_USER_BASE_PRORATE} from "../../utils/cons";

    export default {
        name: "ProdArch",
        data(){
            return{
                myYsfTermRateArray: [],
                activeName: 'tab1',
                loading: false,
                arch_userBaseProductRateInfo: null
            }
        },
        computed: {
            myTermRate() {
                return this.myYsfTermRateArray;
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            loadData() {
                // 用户基础产品费率档案
                this.loading = true;
                this.myYsfTermRateArray = []
                this.getRequest(URL_DATA_USER_BASE_PRORATE).then(resp => {
                    if (resp) {
                        this.arch_userBaseProductRateInfo = resp.data;
                        resp.data.forEach(item1 => {
                            if (item1.templateRateList) {
                                item1.templateRateList.forEach(item2 => {
                                    this.myYsfTermRateArray.push(item2.rate)
                                })
                            }
//
                        })
                    }
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>
